/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'ico-tw': {
    width: 19,
    height: 15,
    viewBox: '0 0 19 15',
    data: `<path pid="0" d="M16.627 3.736c.007.162.01.326.01.49C16.638 9.23 12.925 15 6.132 15c-2.086 0-4.027-.627-5.661-1.702a7.295 7.295 0 0 0 5.467-1.568c-1.616-.03-2.98-1.125-3.45-2.629a3.61 3.61 0 0 0 1.668-.065c-1.689-.348-2.962-1.878-2.962-3.713v-.048a3.61 3.61 0 0 0 1.673.474 3.812 3.812 0 0 1-1.643-3.152c0-.694.182-1.344.5-1.904C3.545 2.984 6.265 4.492 9.335 4.65a3.894 3.894 0 0 1-.096-.863C9.24 1.695 10.893 0 12.932 0c1.062 0 2.022.46 2.695 1.196a7.293 7.293 0 0 0 2.346-.92 3.785 3.785 0 0 1-1.624 2.096 7.232 7.232 0 0 0 2.121-.597 7.615 7.615 0 0 1-1.843 1.961z"/>`
  }
})
